import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/DashboardStyle.module.css';
import DashboardTitle from "./DashboardTitle";
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
const Donate = ()=>{
   
    return( 
        <div><DashBoardLeftProfileMenu/>
         <div className={'containerStyla ' + Style.Dashboardscreen}>
            <Container>
                <DashboardTitle title="DONATE" membertype="Non Member" />
                <Row>
            <Col lg={6}>
                <div className={Style.aboutMembership}>
                    <h3>Donate to MAAD</h3>
                    <p>Your donation will help MAAD meet its goal &amp; objectives. It also helps in meeting costs for initiatives &amp; other expenses incurred by MAAD on a regular basis.</p>
                </div>

                <div className={Style.payOffer}>

                    <div className={Style.box}>
                        <div className={Style.lSide}>
                            <h2>Enter Donation Amount</h2>
                            <input id="txtAmount" placeholder="Donation Amount" type="text" className={Style.fromControl} />
                            <button type="button" className={Style.greenBtn} onclick="DonateNow()">
                                Pay Now
                            </button>
                        </div>
                    </div>
                </div>
            </Col>
            <Col lg={6} className={Style.paddL}>
                <div className={Style.paymentOption}>
                    <h3>PAYMENT OPTIONS</h3>
                    <p>You will be given the option to select the payment option in the next screen</p>
                    <img className={Style.PaymentImg}src="https://mayoalumni.in/images/payment-img.png" alt="" />
                    <img src="https://mayoalumni.in/images/card-img.png" alt=" " />
                </div>
            </Col>
            </Row>
            </Container>
        </div>
        </div>
        )
    }
    
    export default Donate;